






import Vue from 'vue'
import {
  PLANNING_ASSISTANT_SET_EMPLOYEE_FOR_EXCHANGE
} from "@/store/action-types";

export default Vue.extend({
  name: "EmployeeExchangeCellRenderer",

  methods: {
    onAddEmployeeButtonClick (): void {
      // @ts-ignore
      this.$store.dispatch(PLANNING_ASSISTANT_SET_EMPLOYEE_FOR_EXCHANGE, this.params.data)
    }
  }
})
